import { NgModule, ErrorHandler, APP_INITIALIZER } from "@angular/core";
import { Router, UrlSerializer } from "@angular/router";
import { AppConfigService } from "./services/app-config.service";

import {
  BrowserModule,
  BrowserTransferStateModule,
} from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
// import { ServiceWorkerModule } from "@angular/service-worker";

import { IonicStorageModule } from "@ionic/storage";
import { RemoveWhiteSpacePipe } from "./pipes/whitespace";

import { DatePipe } from "@angular/common";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { pageTransition } from "./animations";

import {
  SocialLoginModule,
  SocialAuthServiceConfig,
  FacebookLoginProvider,
} from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { TransferHttpCacheModule } from "@nguniversal/common";
import * as Sentry from "@sentry/angular";

import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha";
import { AuthService } from "./auth/auth.service";
import { environment } from "src/environments/environment";
import { ComponentsModule } from "./components/components.module";
import { LowerCaseUrlSerializer } from './services/lowerCaseSerializer.service';

export function appInit(appConfigService: AppConfigService) {
  return (): Promise<any> => {
    return appConfigService.load();
  };
}

@NgModule({
  declarations: [AppComponent, RemoveWhiteSpacePipe],
  entryComponents: [],
  imports: [
    BrowserModule.withServerTransition({ appId: "hyprop" }),
    BrowserTransferStateModule,
    IonicModule.forRoot({
      sanitizerEnabled: true,
      mode: "md",
      animated: true,
      hardwareBackButton: true,
      statusTap: true,
      swipeBackEnabled: true,
      menuType: "push",
      tabButtonLayout: "icon-top",
      spinner: "bubbles",
      refreshingSpinner: "bubbles",
      loadingSpinner: "bubbles",
      infiniteLoadingSpinner: "bubbles",
      navAnimation: pageTransition,
    }),
    IonicStorageModule.forRoot({
      name: "__hyprop",
    }),
    TransferHttpCacheModule,
    HttpClientModule,
    AppRoutingModule,
    // ServiceWorkerModule.register("ngsw-worker.js", {
    //   enabled: environment.production,
    // }),
    SocialLoginModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    ComponentsModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    DatePipe,
    AppConfigService,
    AuthService,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [AppConfigService],
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha_key,
    },
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(environment.social_google_key),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider(
              environment.social_facebook_key,
              {
                scope: "email,user_gender,user_birthday",
                fields:
                  "id,location,birthday,email,picture,first_name,last_name",
                return_scopes: true,
                enable_profile_selector: true,
                version: "v11.0",
              }
            ),
          },
        ],
      } as SocialAuthServiceConfig,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(trace: Sentry.TraceService) {}
}
